import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { useAddedToBagContextStore } from "@faire/retailer-visitor-shared/components/Notifications/AddedToBag/AddedToBagStore";
export var useAddedToBag = function() {
    var _useAddedToBagContextStore = _sliced_to_array(useAddedToBagContextStore([
        "shouldIgnore",
        "ignoredContainers"
    ]), 2), _useAddedToBagContextStore_ = _useAddedToBagContextStore[0], shouldIgnore = _useAddedToBagContextStore_.shouldIgnore, ignoredContainers = _useAddedToBagContextStore_.ignoredContainers, setAddToBagContextStore = _useAddedToBagContextStore[1];
    var ignoreContainer = function(container, ignore) {
        var newIgnoredContainers = _object_spread_props(_object_spread({}, ignoredContainers), _define_property({}, container, ignore));
        if (ignoredContainers[container] !== ignore) {
            setAddToBagContextStore({
                ignoredContainers: newIgnoredContainers
            });
        }
        setAddToBagContextStore({
            shouldIgnore: ignore || Object.values(newIgnoredContainers).some(function(value) {
                return value;
            })
        });
    };
    return {
        shouldIgnore: shouldIgnore,
        ignoreContainer: ignoreContainer
    };
};
